import { css } from '@emotion/core';

import colors from '../config/colors';

const header = css`
  [aria-describedby='popover-active-order'] {
    color: ${colors.black} !important;
  }

  [aria-describedby='popover-active-order']::before {
    background-color: ${colors.lightGray} !important;
  }

  .navbar-inverse .navbar-nav > li {
    position: relative;

    &::before {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: ${colors.emerald};
      opacity: 0;
      transition: opacity 500ms ease-in-out;
    }
  }

  .navbar-inverse .navbar-nav > li.is-active {
    &:before {
      opacity: 1;
    }

    a:focus,
    a:visited,
    a:active {
      color: white;
    }
  }
`;

export { header };
